import {Alert, CircularProgress, Grid} from "@mui/material";
import AdminInner from "../../../components/layout/admin_inner";
import {useApiManager} from "../../../components/utils/api";
import {EmpManagerRestControllerApiFactory, ManagerStats} from "arteco-api-client-ts";
import React, {useEffect, useState} from "react";
import moment from "moment/moment";
import {EfficiencyIndicators} from "./emp_productivity_cads";
import {EmpProductivityChart} from "./emp_productivity_chart";
import {EmpProductivityBudgets} from "./emp_productivity_budgets";

export function EmployeeProductivityPage() {
	const apiManager = useApiManager();
	const managerCtrl = apiManager.factory(EmpManagerRestControllerApiFactory);

	const [stats, setStats] = useState<ManagerStats | undefined>(undefined);

	useEffect(() => {
		apiManager
		.execute(managerCtrl.managerStats(undefined))
		.then(resp => {
			setStats(resp);
		})
	}, []);


	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm>
					<AdminInner title={"Productividad"}>

						{stats == undefined && (
							<Alert icon={false} color="warning">
								<CircularProgress size="1em"/> &nbsp; Loading...
							</Alert>
						)}

						{stats && (stats.dedication?.workedHours || 0) == 0 && (
							<Alert color="info">
								No hay datos para mostrar
							</Alert>
						)}

						{stats && (stats.dedication?.workedHours || 0) > 0 && (
							<>
								<p>
									Datos actualizados a fecha {moment(stats.lastMod).format("DD/MM/YY HH:mm")}
								</p>
								<EfficiencyIndicators stats={stats}/>
								<EmpProductivityChart stats={stats}/>
								<EmpProductivityBudgets stats={stats}/>
							</>
						)}

					</AdminInner>
				</Grid>
			</Grid>
		</>
	)
}